import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux';
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useParams, useNavigate } from "react-router-dom";
import { ErrorBoundary } from 'react-error-boundary';
import ErrorHandler from '../../../controls/ErrorHandler';
import useFetchWithCancellation from '../../../../customhooks/useFetchWithCancellation';

function PCPInvoiceMeetingForm({ _inputValue, afterSave }) {
    const { fetchData } = useFetchWithCancellation();
    const navigate = useNavigate();
    const { id } = useParams();
    const formRef = useRef();
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const state = useSelector(state => state);

    const [inputValue, setInputValue] = useState({
        Id: 0,
        Description: "",
        Rate: 0,
        Amount: 0,
        TotalHours: 0,
        isManual: true,
        MeetingDate: "",
    });


    const SaveData = ((e) => {
        e.preventDefault();
        e.stopPropagation();

        if (formRef.current.checkValidity() === false) {
            setValidated(true);
        }
        else {
            if (!inputValue.MeetingDate) {
                setValidated(true);
                return false;
            }
           let obj = JSON.parse(JSON.stringify(inputValue));
         //  obj.MeetingDate = dateDisplayFormater(inputValue.MeetingDate);
            afterSave(obj);
        }
    });

    const handleChange = ((e) => {
        const name = e.target.name;
        let value = e.target.value;
        let maxLength = e.target.maxLength;
        if (e.target.type == "checkbox") {
            value = e.target.checked;
        }
        else {
            if (maxLength && maxLength > 0 && value.length > maxLength) {
                return;
            }
        }
        setInputValue(c => ({ ...c, [name]: value }));
    });
    
    useEffect(() => {
        setInputValue({ ...inputValue, ..._inputValue });
    }, []);

    const handleDatePickerChange = ((value, name) => {
        setInputValue(c => ({ ...c, [name]: value }));
    })
   
    return (
        <ErrorBoundary FallbackComponent={ErrorHandler}>
            <Form noValidate validated={validated} ref={formRef} >
                <Row className="mb-6">
                    <Col md="12">
                        <Row className="mb-6">
                            <Col>
                                <h5 className="d-inline-block">Meetings</h5>
                            </Col>
                            <Col md="auto">

                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mb-6">
                    <Col md="12">
                        <Row className="mb-3">
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Date<code className='required-symbol'>*</code></Form.Label>
                                    <DatePicker className="form-control" required
                                        dateFormat="yyyy-MM-dd"
                                        showYearDropdown
                                        showMonthDropdown
                                        selected={inputValue.MeetingDate}
                                        onChange={(val) => { handleDatePickerChange(val, "MeetingDate") }}
                                        scrollableMonthYearDropdown
                                    />
                                    <Form.Control.Feedback type="invalid">Please provide Date</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Total Hours<code className='required-symbol'>*</code></Form.Label>
                                    <Form.Control required name="TotalHours" type="text" value={inputValue.TotalHours} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">Please provide Total hours</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Description<code className='required-symbol'>*</code></Form.Label>
                                    <Form.Control as="textarea" row="8" required type="text" name="Description" value={inputValue.Description} onChange={handleChange} autoComplete="off" />
                                    <Form.Control.Feedback type="invalid">Please provide Description</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-2" >
                            <Col md={12} className="text-center">
                                <Form.Group>
                                    <Button variant="primary" type="button" onClick={(e) => SaveData(e)} disabled={loading} className="float-end">
                                        Save
                                        {loading ? <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" /> : ""}
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </Form>
        </ErrorBoundary>
    )
}
export default (PCPInvoiceMeetingForm)